module.exports = __webpack_public_path__ + "static/media/19ESCAP4.fedbf31c.jpg";